<template>
<div class="alimentacao">
  <div class="extensao_banner">
    <BreadCrumb :breadcrumb="breadcrumb" class="bcp" />
    <h1>SASUMA / {{ $t("UMA_LANG_SASUMA_HOMEMENU_ALOJAMENTO") }}</h1>
  </div>
  <div class="row align-center">
    <div class="small-10 medium-10 large-9 columns bolsaslist">
        <p class="introbolsatexto alimentacaotexto" 
        v-html="$t('UMA_LANG_SASUMA_ALOJAMENTO_INTRO')"></p>
        <div class="downloaddocuments">
          <a target="_blank" href="https://testuma.sharepoint.com/:b:/s/outrasestruturas/sasuma/ESqZOfRIdd1DgycVQk3WBNgBvvpdduBU_w-THHoLzGzN4A?e=9mTeed">
              <span class="download_icon_large">
                  <i class="ms-Icon ms-Icon--Download"></i>
              </span>{{ $t("UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARREGULAMENTO")}}
          </a>
        </div>
        <div class="downloaddocuments">
          <a target="_blank" href="https://testuma.sharepoint.com/:i:/s/outrasestruturas/sasuma/areaprivada/alojamento/ET8TEvrMNQ9Alt9aO4760EMBYbgicQsrAKcyBLz4nNv9EQ?e=ObEFet">
              <span class="download_icon_large">
                  <i class="ms-Icon ms-Icon--Download"></i>
              </span>{{ $t("UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOHOTELARIA")}} 
          </a>
        </div>
        <div class="downloaddocuments">
          <a target="_blank" href="https://testuma.sharepoint.com/:b:/s/outrasestruturas/sasuma/EQ4q8B8l9HRPsy9AUsW5m9YB409M9Rubn-1hg0hsdJM7Iw?e=QKpqcu">
              <span class="download_icon_large">
                  <i class="ms-Icon ms-Icon--Download"></i>
              </span>{{ $t("UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOACADEMIA")}}
          </a>
        </div>
        <div class="downloaddocuments">
          <a target="_blank" href="https://testuma.sharepoint.com/:i:/s/outrasestruturas/sasuma/areaprivada/alojamento/ERZdD_cQwhBAkAxuMG1RncgBc92sPTTLxLtfWmzuKf-79Q?e=zw0sfY">
            <span class="download_icon_large">
                <i class="ms-Icon ms-Icon--Download"></i>
            </span>{{ $t("UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOSERVICOS")}} 
          </a>
        </div>
    </div>
  </div>
  <Candidaturas />
  <AlojamentoGrid />
  <div class="row align-center">
    <div class="small-10 medium-10 large-9 columns bolsaslist">
      <HomeSectionTitle 
        class="xpto"
        :title="$t('UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM')" />
      <AreaSlider />  
    </div>
  </div>
</div>
</template>

<script>
import { ref, onMounted } from "vue";
import { i18n } from "@/main.js";
import { onBeforeRouteLeave } from 'vue-router';
import BreadCrumb from "@/components/BreadCrumb.vue";
import HomeSectionTitle from "@/components/HomeSectionTitle.vue";
import AlojamentoGrid from "@/components/AlojamentoGrid.vue";
import AreaSlider from "@/components/areaslider/AreaSlider.vue";
import Candidaturas from "@/containers/alojamento/candidaturas.vue";


export default {
  components: {
    BreadCrumb,
    HomeSectionTitle,
    AlojamentoGrid,
    AreaSlider,
    Candidaturas
  },
  setup () {
    
    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";
    
    const breadcrumb = ref([]);
    onMounted(() => {
      breadcrumb.value = [
        { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
        { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
        { ID: 3, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
        { ID: 4, text: t("breadcrumb.sas"), route: { to: "/" } },
        { ID: 5, text: t("breadcrumb.alojamento"), href: "#" }
      ]
    })

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    return {
      breadcrumb
    }
  }
}
</script>

<style lang="scss" scoped>
.extensao_banner h1 {
  text-align: center;
  font-family: "Montserrat Bold";
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0, -10px, 0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}

.bolsaslist {
  padding-right: 0;
  padding-left: 0;
  max-width: 1330px;
}

@media (max-width: 1350px) {
  .bolsaslist {
    padding-right: 0;
    padding-left: 0;
    max-width: 100%;
  }
}

@media (max-width: 1280px) {
  .bolsaslist {
    padding-left: 0;
    padding-right: 0;
  }
}

.introbolsatexto {
  margin-top: 60px;
  margin-left: 10px;
  margin-right: 10px;
  padding-right: 15px;
  padding-left: 50px;
  font-size: 17px;
  font-family: "Montserrat Light";
  line-height: 2.3;
  color: #494d52eb;
  margin-bottom: 90px;
}

.introbolsatexto.alimentacaotexto{
  margin-bottom: 20px;
}


@media (max-width: 1400px) {
  .introbolsatexto {
    margin-left: 0px;
    margin-right: 0px;
    padding-right: 0px;
    padding-left: 0px;
    margin-top: 30px;
  }
}

@media (max-width: 767px) {
  .introbolsatexto {
    font-size: 14px;
    line-height: 2;
    color: #333333;
    margin-top: 0px;
    margin-bottom: 40px;
    padding-top: 15px;
    padding-right: 0px;
    padding-left: 0px;
  }
}


@media (max-width: 767px) {
  .large-9 {
    flex: 0 0 100%;
  }

  .bolsaslist {
    padding-left: 5%;
    padding-right: 5%;
  }
}



.downloaddocuments{
  margin-left: 60px;
  margin-right: 10px;
  font-family: "PT Sans";
  margin-top: 10px;
  margin-bottom: 90px;
}

.downloaddocuments:first-of-type {
  margin-bottom: 0px;
  margin-top: 50px;
}


.downloaddocuments:nth-of-type(2) {
  margin-bottom: 0px;
}

.downloaddocuments:nth-of-type(3) {
  margin-bottom: 0px;
}

.downloaddocuments:last-of-type {
  margin-bottom: 80px!important;
}


.downloaddocuments a:hover {
  font-family: "Montserrat Semibold";
}

@media (max-width: 1400px){
  .downloaddocuments{
    margin-left: 0;
    margin-right: 0;
  }
}

.downloaddocuments.nomargin{
  margin-left: 0;
}

.downloaddocuments a{
  color: #6eb7ec;
  font-family: "Montserrat";
  font-size: 20px;
}

.downloaddocuments i{
  margin-right: 8px;
  font-weight: 600 !important;
  font-size: 20px;
  color: #6eb7ec;
}


@media (max-width: 767px){
  .downloaddocuments a{
    font-size: 14px;
  }
}
</style>